/**
 * withArticles
 * HOC for wrapping the provided component with ArticlesProvider
 */

import React from 'react'

import ArticlesProvider from './articles-provider'

export default function withArticles(WrappedComponent) {
  return function ArticlesProviderHOC(props) {
    return (
      <ArticlesProvider>
        <WrappedComponent {...props} />
      </ArticlesProvider>
    )
  }
}
